import Vue from 'vue';
import __vue_component__ from '../icons/Icon.vue.js';

/**
 * @deprecated Use SdsSnackbar instead
 */
var script = Vue.extend({
    name: 'ToastNotification',
    props: {
        text: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        iconClass: function () {
            switch (this.type) {
                case 'error':
                    return 'icon-close_circle_filled';
                case 'info':
                    return 'icon-check_circle_filled';
                case 'warning':
                    return 'icon-warning_triangle_filled';
                default:
                    return '';
            }
        },
        showWhiteBackground: function () {
            return this.type !== 'warning';
        },
    },
    components: {
        Icon: __vue_component__,
    },
});

export default script;
